<section class="approval-page">
  <article class="approval-card">
    <h1>Sender Identity Approval</h1>

    @if (loading) {
      <p aria-live="polite">Verifying your approval link…</p>
    } @else if (ready) {
      <p class="status-copy status-copy-info" aria-live="polite">{{ message }}</p>

      <div class="approval-actions">
        <button type="button" class="approval-btn approval-btn-primary" [disabled]="actionLoading" (click)="approve()">
          {{ pendingAction === 'approve' ? 'Submitting…' : 'Approve' }}
        </button>
        <button type="button" class="approval-btn approval-btn-secondary" [disabled]="actionLoading" (click)="decline()">
          {{ pendingAction === 'decline' ? 'Submitting…' : 'Decline' }}
        </button>
      </div>

      @if (retryableErrorMessage) {
        <p class="status-copy status-copy-error" aria-live="polite">{{ retryableErrorMessage }}</p>
      }
    } @else {
      <p
        class="status-copy"
        [class.status-copy-success]="status === 'success'"
        [class.status-copy-info]="status === 'info'"
        [class.status-copy-error]="status === 'error'"
        aria-live="polite"
      >
        {{ message }}
      </p>
    }
  </article>
</section>
